import axios from "axios"
import { nonAuthAxios } from "./axios-global"

export const userLogin = async (payload = {}) => {
  const res = await nonAuthAxios.post("/users/token/", payload)
  return res
}

export const userForgotPassword = async (payload = {}) => {
  const res = await nonAuthAxios.post("/auth/password/reset/", payload)
  return res
}

export const userConfirmPassword = async (payload = {}) => {
  const res = await nonAuthAxios.post("/auth/password/reset/confirm", payload)
  return res
}

export const userChangePassword = async (payload = {}) => {
  const res = await axios.post("/auth/password/change/", payload)
  return res
}

export const userUpdateProfile = async (payload = {}) => {
  const res = await axios.patch("/users/profile/update/", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return res
}
